export const LIST_PATIENT_REQUEST = 'LIST_PATIENT_REQUEST'
export const LIST_PATIENT_SUCCESS = 'LIST_PATIENT_SUCCESS'
export const LIST_PATIENT_FAIL = 'LIST_PATIENT_FAIL'

export const LIST_PATIENT_RELATION_SUMMARY_REQUEST = 'LIST_PATIENT_RELATION_SUMMARY_REQUEST'
export const LIST_PATIENT_RELATION_SUMMARY_SUCCESS = 'LIST_PATIENT_RELATION_SUMMARY_SUCCESS'
export const LIST_PATIENT_RELATION_SUMMARY_FAIL = 'LIST_PATIENT_RELATION_SUMMARY_FAIL'

export const HISTORY_LOG_PATIENT_REQUEST = 'HISTORY_LOG_PATIENT_REQUEST'
export const HISTORY_LOG_PATIENT_SUCCESS = 'HISTORY_LOG_PATIENT_SUCCESS'
export const HISTORY_LOG_PATIENT_FAIL = 'HISTORY_LOG_PATIENT_FAIL'

export const LIST_PATIENT_SUMMARY_REQUEST = 'LIST_PATIENT_SUMMARY_REQUEST'
export const LIST_PATIENT_SUMMARY_SUCCESS = 'LIST_PATIENT_SUMMARY_SUCCESS'
export const LIST_PATIENT_SUMMARY_FAIL = 'LIST_PATIENT_SUMMARY_FAIL'

export const CREATE_PATIENT_REQUEST = 'CREATE_PATIENT_REQUEST'
export const CREATE_PATIENT_SUCCESS = 'CREATE_PATIENT_SUCCESS'
export const CREATE_PATIENT_FAIL = 'CREATE_PATIENT_FAIL'

export const DETAIL_PATIENT_REQUEST = 'DETAIL_PATIENT_REQUEST'
export const DETAIL_PATIENT_SUCCESS = 'DETAIL_PATIENT_SUCCESS'
export const DETAIL_PATIENT_FAIL = 'DETAIL_PATIENT_FAIL'

export const UPDATE_PATIENT_REQUEST = 'UPDATE_PATIENT_REQUEST'
export const UPDATE_PATIENT_SUCCESS = 'UPDATE_PATIENT_SUCCESS'
export const UPDATE_PATIENT_FAIL = 'UPDATE_PATIENT_FAIL'

export const DELETE_PATIENT_REQUEST = 'DELETE_PATIENT_REQUEST'
export const DELETE_PATIENT_SUCCESS = 'DELETE_PATIENT_SUCCESS'
export const DELETE_PATIENT_FAIL = 'DELETE_PATIENT_FAIL'

export const SYNC_SATUSEHAT_PATIENT_REQUEST = 'SYNC_SATUSEHAT_PATIENT_REQUEST'
export const SYNC_SATUSEHAT_PATIENT_SUCCESS = 'SYNC_SATUSEHAT_PATIENT_SUCCESS'
export const SYNC_SATUSEHAT_PATIENT_FAIL = 'SYNC_SATUSEHAT_PATIENT_FAIL'